import update from 'immutability-helper';

export function isDraftItemId(itemId: string | undefined) {
  return itemId && itemId.indexOf('DRAFT') === 0;
}

export function deleteVariation(variation) {
  return update(variation, {$set: {...variation, Delete: true}});
}
